import { getUserName } from './window-utils';
import { MessageType, createMessage } from '../message';

/**
 * @typedef { Object } Session
 * @property { string } sessionId - User ID string used as sessionId.
 * @property { number } timestamp - Timestamp when session was created.
 */

export const getInitialMessage = (sessionId) => {
  const authUser = getUserName();
  return createMessage(MessageType.BOT, {
    responseSummary: {
      // eslint-disable-next-line max-len
      summaryAnswer: 'What can I help you with today?',
      relatedQuestions: {
        suggestedQuestions: [],
      }
    },
  }, {
    sessionId,
    // Set to true since no feedback prompt should be shown for initial message
    feedbackProvided: true,
    timestamp: Date.now(),
    isInitialMessage: true,
  });
};
